// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cell .disabled[data-v-a776715c] {\n  opacity: 0.5;\n}\n@media only screen and (max-width: 480px) {\n[data-v-a776715c] .el-dialog {\n    width: 90%;\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
